/* global module, require */
const THREE = require('three'),
	steel = require('../mat/steel'),
	unit = require('../unit');

function makeSlotSizes() {
	var slots = {};
	slots[unit.mm(42.4)] = { a: unit.mm(24), b: unit.mm(24) };
	slots[unit.mm(48.3)] = { a: unit.mm(30), b: unit.mm(27) };

	return slots;
}

const slotSizes = makeSlotSizes();

function makeCircleVertices(segments, count, radius, skip = 0) {
	const increment = (Math.PI * 2) / segments;
	var vertices = [];
	var angle = skip * increment;

	for (var i = 0; i < count; i++) {
		vertices.push(
			new THREE.Vector2(radius * Math.cos(angle), radius * Math.sin(angle))
		);

		angle += increment;
	}

	return vertices;
}

function makeGeometry(between, diameter) {
	const slot = slotSizes[diameter];
	const radius = diameter / 2;
	const bhalf = slot.b / 2;
	const cutup = slot.a - radius;

	const theta = Math.asin(bhalf / radius);
	const cutdown = radius * Math.cos(theta);

	const shape = new THREE.Shape([
		new THREE.Vector2(-bhalf, -cutdown),
		new THREE.Vector2(-bhalf, cutup),
		new THREE.Vector2(bhalf, cutup),
		new THREE.Vector2(bhalf, -cutdown),
		...makeCircleVertices(24, 18, radius, -2),
	]);

	return new THREE.ExtrudeBufferGeometry(shape, {
		depth: between.length(),
		bevelEnabled: false,
	});
}

module.exports = function makeSlottedTube({
	start,
	between,
	diameter,
	height,
}) {
	const mesh = new THREE.Mesh(makeGeometry(between, diameter), steel);

	mesh.rotation.y = Math.atan2(between.x, between.z);
	mesh.position.copy(start);
	mesh.position.y = height;

	return mesh;
};
